export default `float d;
  p.z-=6.;
  p.yz*=rotate2D(1.57);
  for(int j=0;j++<4;)
    p=abs(fract(abs(p))-.1),
    d=dot(p.z,max(p.x,p.y))-.001,
    d-=.8*min(d,dot(p,p-vec3(-1.0)));
  return d*4.;
}`